import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import { SxProps, Theme } from '@mui/material/styles';
import MuiTextField, {
  TextFieldProps as MuiTextFieldProps,
} from '@mui/material/TextField';
import { forwardRef } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { FormLabel } from '../FormLabel';
import { type InfoIconPopoverProps } from '../InfoIconPopover';

export type ExtraConfig = {
  inputHelpText?: string | null;
  labelStyles?: SxProps<Theme>;
};

export type TextFieldProps = Omit<MuiTextFieldProps, 'size' | 'popover'> &
  Partial<InfoIconPopoverProps> &
  ExtraConfig;

export const TextField = forwardRef<HTMLInputElement, TextFieldProps>(
  function Forwarded(
    {
      id = `textField-${uuidv4()}`,
      label,
      labelStyles,
      infoPopover,
      infoPopoverMaxWidth,
      infoPopoverAnchorOrigin,
      infoPopoverTransformOrigin,
      inputHelpText,
      ...props
    },
    ref
  ) {
    return (
      <Stack width={props.fullWidth ? '100%' : 'inherit'}>
        {(label || infoPopover) && (
          <FormLabel
            htmlFor={id}
            required={props.required}
            sx={labelStyles}
            infoPopover={infoPopover}
            infoPopoverMaxWidth={infoPopoverMaxWidth}
            infoPopoverAnchorOrigin={infoPopoverAnchorOrigin}
            infoPopoverTransformOrigin={infoPopoverTransformOrigin}
          >
            {label}
          </FormLabel>
        )}
        <FormControl>
          <MuiTextField
            id={id}
            {...props}
            ref={ref}
            size="small"
            label={inputHelpText}
          />
        </FormControl>
      </Stack>
    );
  }
);
